module.exports = __webpack_public_path__ + "static/media/media4.c392ac93.png";